var map = {
	"./Account/Create": 8982,
	"./Account/Create.vue": 8982,
	"./Admin/Create": 8299,
	"./Admin/Create.vue": 8299,
	"./Admin/Edit": 2458,
	"./Admin/Edit.vue": 2458,
	"./Admin/Index": 7399,
	"./Admin/Index.vue": 7399,
	"./Admin/Profile": 8429,
	"./Admin/Profile.vue": 8429,
	"./Admin/Show": 4763,
	"./Admin/Show.vue": 4763,
	"./Blog/Category/Create": 1858,
	"./Blog/Category/Create.vue": 1858,
	"./Blog/Category/Index": 1347,
	"./Blog/Category/Index.vue": 1347,
	"./Blog/Create": 9575,
	"./Blog/Create.vue": 9575,
	"./Blog/Index": 2682,
	"./Blog/Index.vue": 2682,
	"./Campaign/Create": 9316,
	"./Campaign/Create.vue": 9316,
	"./Campaign/History/Index": 6220,
	"./Campaign/History/Index.vue": 6220,
	"./Campaign/Index": 6579,
	"./Campaign/Index.vue": 6579,
	"./Configuration/Index": 7856,
	"./Configuration/Index.vue": 7856,
	"./Creator/Index": 3323,
	"./Creator/Index.vue": 3323,
	"./Customer/Index": 9500,
	"./Customer/Index.vue": 9500,
	"./Customer/Internal": 6781,
	"./Customer/Internal.vue": 6781,
	"./Customer/Rating/Index": 1427,
	"./Customer/Rating/Index.vue": 1427,
	"./Dashboard": 7025,
	"./Dashboard.vue": 7025,
	"./DashboardOld": 1690,
	"./DashboardOld.vue": 1690,
	"./Fulfillment/Index": 8887,
	"./Fulfillment/Index.vue": 8887,
	"./Gallery/Index": 2396,
	"./Gallery/Index.vue": 2396,
	"./Giftcard/Create": 9829,
	"./Giftcard/Create.vue": 9829,
	"./Giftcard/Edit": 7241,
	"./Giftcard/Edit.vue": 7241,
	"./Giftcard/Index": 6411,
	"./Giftcard/Index.vue": 6411,
	"./Logs/Index": 4688,
	"./Logs/Index.vue": 4688,
	"./Logs/Show": 4666,
	"./Logs/Show.vue": 4666,
	"./Order/Create": 8669,
	"./Order/Create.vue": 8669,
	"./Order/Delivery": 7752,
	"./Order/Delivery.vue": 7752,
	"./Order/Index": 1099,
	"./Order/Index.vue": 1099,
	"./Order/Show": 8181,
	"./Order/Show.vue": 8181,
	"./Order/Test": 4118,
	"./Order/Test.vue": 4118,
	"./PgcGiftcard/Create": 2108,
	"./PgcGiftcard/Create.vue": 2108,
	"./PgcGiftcard/Index": 9432,
	"./PgcGiftcard/Index.vue": 9432,
	"./PgcGiftcard/Show": 9200,
	"./PgcGiftcard/Show.vue": 9200,
	"./Product/Category/Create": 9183,
	"./Product/Category/Create.vue": 9183,
	"./Product/Category/Index": 8147,
	"./Product/Category/Index.vue": 8147,
	"./Product/Category/Ingredient/Index": 4938,
	"./Product/Category/Ingredient/Index.vue": 4938,
	"./Product/Category/Topping/Index": 425,
	"./Product/Category/Topping/Index.vue": 425,
	"./Product/Create": 2043,
	"./Product/Create.vue": 2043,
	"./Product/Deal/Create": 4450,
	"./Product/Deal/Create.vue": 4450,
	"./Product/Deal/Index": 538,
	"./Product/Deal/Index.vue": 538,
	"./Product/Index": 8198,
	"./Product/Index.vue": 8198,
	"./Product/Price/Index": 780,
	"./Product/Price/Index.vue": 780,
	"./Product/Size/Index": 5145,
	"./Product/Size/Index.vue": 5145,
	"./Promo/Create": 8114,
	"./Promo/Create.vue": 8114,
	"./Promo/Index": 4073,
	"./Promo/Index.vue": 4073,
	"./Report/Deliveries/Analytics": 5942,
	"./Report/Deliveries/Analytics.vue": 5942,
	"./Report/Deliveries/Reports": 1432,
	"./Report/Deliveries/Reports.vue": 1432,
	"./Report/Order": 7997,
	"./Report/Order.vue": 7997,
	"./Report/Promo": 6189,
	"./Report/Promo.vue": 6189,
	"./Report/Sales/Analytics": 9565,
	"./Report/Sales/Analytics.vue": 9565,
	"./Report/Sales/Platform": 1902,
	"./Report/Sales/Platform.vue": 1902,
	"./Report/Sales/Product": 9174,
	"./Report/Sales/Product.vue": 9174,
	"./Report/Sales/Store": 546,
	"./Report/Sales/Store.vue": 546,
	"./Report/Signup": 5670,
	"./Report/Signup.vue": 5670,
	"./Rider/Create": 7645,
	"./Rider/Create.vue": 7645,
	"./Rider/Index": 6393,
	"./Rider/Index.vue": 6393,
	"./Role/Index": 4976,
	"./Role/Index.vue": 4976,
	"./Role/Permission": 4355,
	"./Role/Permission.vue": 4355,
	"./Setting/AppCompatibility": 8970,
	"./Setting/AppCompatibility.vue": 8970,
	"./Setting/BusinessHour": 1198,
	"./Setting/BusinessHour.vue": 1198,
	"./Setting/Giftcard": 2675,
	"./Setting/Giftcard.vue": 2675,
	"./Setting/Loyalty": 7219,
	"./Setting/Loyalty.vue": 7219,
	"./Setting/PriceSlash": 35,
	"./Setting/PriceSlash.vue": 35,
	"./Setting/ReferralReward": 350,
	"./Setting/ReferralReward.vue": 350,
	"./Store/AvailableStores": 2685,
	"./Store/AvailableStores.vue": 2685,
	"./Store/City/Index": 9536,
	"./Store/City/Index.vue": 9536,
	"./Store/Create": 868,
	"./Store/Create.vue": 868,
	"./Store/Details": 2142,
	"./Store/Details.vue": 2142,
	"./Store/Index": 3751,
	"./Store/Index.vue": 3751,
	"./Store/Toppings": 1786,
	"./Store/Toppings.vue": 1786,
	"./Transaction/Index": 364,
	"./Transaction/Index.vue": 364,
	"./Transaction/Refund": 3424,
	"./Transaction/Refund.vue": 3424,
	"./TutorialVideo/Index": 5337,
	"./TutorialVideo/Index.vue": 5337,
	"./User/Index": 8456,
	"./User/Index.vue": 8456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;